import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "fan-facet-area pb-100" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "fan-facet-wrap" }
const _hoisted_4 = { class: "d-flex justify-content-lg-between justify-content-center gap-3 gap-md-4 gap-lg-0 align-items-center flex-wrap" }
const _hoisted_5 = ["data-aos-delay"]
const _hoisted_6 = { class: "counter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facts, (fact, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "fan-facet-single-item",
              "data-aos": "fade-up",
              "data-aos-duration": "1000",
              "data-aos-delay": (index + 1) * 100
            }, [
              _createElementVNode("h1", null, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(fact.value), 1),
                _createElementVNode("span", null, _toDisplayString(fact.suffix), 1)
              ]),
              _createElementVNode("p", null, _toDisplayString(fact.label), 1)
            ], 8, _hoisted_5))
          }), 128))
        ])
      ])
    ])
  ]))
}